import { http } from 'msw';
import { WebServices } from 'BMapsSrc/WebServices';
import { setupWorker } from 'msw/browser';
import { subscribe } from 'BMapsSrc/redux/subscribers/stateChangeSubscriber';
import * as MockData from 'BMapsSrc/mocks/mock_job_manager';

const jobManager = new MockData.MockJobManager();

const handlers = [
    http.post(`${WebServices.JOBS_URL}retrieve-job-results`, async ({ request }) => {
        const data = await request.clone().json();
        const response = jobManager.getResultForJob(data);
        return (
            new Response(
                JSON.stringify(response),
                {
                    status: 200,
                    headers: { 'Content-Type': 'application/json' },
                }
            )
        );
    }),
    http.get(`${WebServices.JOBS_URL}get-jobs`, ({ request }) => {
        const response = jobManager.getJobs();
        return (
            new Response(
                JSON.stringify(response),
                {
                    status: 200,
                    headers: { 'Content-Type': 'application/json' },
                }
            )
        );
    }),
    http.post(`${WebServices.JOBS_URL}start-job`, async ({ request }) => {
        const data = await request.clone().json();
        const response = jobManager.createJob(data);
        return (
            new Response(
                JSON.stringify(response),
                {
                    status: 200,
                    headers: { 'Content-Type': 'application/json' },
                }
            )
        );
    }),
    http.post(`${WebServices.JOBS_URL}delete-job`, async ({ request }) => {
        const data = await request.clone().json();
        const response = jobManager.deleteJob(data);
        return (
            new Response(
                JSON.stringify(response),
                {
                    status: 200,
                    headers: { 'Content-Type': 'application/json' },
                }
            )
        );
    }),
];

export default class JobmanMockServiceWorker {
    static Init() {
        const worker = setupWorker(...handlers);
        subscribe('prefs.UseMockServiceWorker', (useMockServiceWorker) => {
            if (useMockServiceWorker) {
                const isDev = window.location.pathname.match(/\/dev\//);
                const url = isDev ? '/dev/mockServiceWorker.js' : '/app/mockServiceWorker.js';
                worker.start({
                    serviceWorker: { url },
                    onUnhandledRequest: 'bypass',
                });
                JobmanMockServiceWorker.WORKING = true;
            } else if (JobmanMockServiceWorker.WORKING) {
                worker.stop();
                JobmanMockServiceWorker.WORKING = false;
            } else {
                // Already stopped, don't need to do anything
            }
        });
    }
}
